<script setup>
import { RouterLink, RouterView } from 'vue-router'
import { ref } from 'vue'
import router from './router'

import { useAuthStore } from './stores/auth.store'

const $auth = useAuthStore()

// console.log($auth)
// console.log($auth.user)

if ($auth.user === null || $auth.user === undefined) {
  router.push({ path: 'auth' })
}

async function Logout() {
  $auth.logout()
}
</script>

<template>
  <v-container class="pa-0">
    <header>
      <!-- <img alt="Vue logo" class="logo" src="@/assets/logo.svg" width="125" height="125" /> -->
      <div class="wrapper">
        <div>
          <!-- <v-btn prepend-icon="mdi-logout" @click="Logout"> Выйти </v-btn> -->
          <!-- <RouterLink to="/">Главная</RouterLink> -->
          <!-- <RouterLink to="/list"
            ><v-btn class="ma-2" color="primary" icon="mdi-home"> </v-btn
          ></RouterLink> -->
          <!-- <RouterLink to="/about">О приложении</RouterLink> -->
        </div>
      </div>
    </header>
    <RouterView />
    <!-- <footer>
      <div class="wrapper">
        <div>
          <RouterLink to="/list">
            <v-btn class="ma-2" color="primary" icon="mdi-home"></v-btn>
          </RouterLink>
        </div>
      </div>
    </footer> -->
  </v-container>
</template>

<style lang="less" scoped>
header {
  margin-bottom: 20px;
}

footer {
  position: fixed;
  bottom: 0;
  right: 50%;
  z-index: 99;

  .wrapper {
    margin: 20px;
  }
}
</style>
